(function (angular) {
    'use strict';
    angular.module('SMART2').
	directive('documentFilter', ['$translate', '$filter', 'APPCONSTANTS', 'commonUtilities', 'globalSearchService', 'RESTApi', documentFilterFunc]);
    function documentFilterFunc($translate, $filter, APPCONSTANTS, commonUtilities, globalSearchService, RESTApi) {
        return {
            restrict: "E",
            scope: {
                filterLinker: "=",
                currentFilter: "=?cFilter"
            },
            link: function (scope, element, attrs) {
                var filterParam = [], advFilterInputParam, appliedFilter = [];
                if (scope.filterLinker) {
                    var controlTmpl = {
                        "dropdown": { tmpl: "radio.html", IsData: true, selected: {}, defaultSelected: {} },
                        "autosuggest": { tmpl: "multiselect.html", IsData: true, selected: "", checkElem: { text: "Selected" } },
                        "daterange": { tmpl: "dateRange.html", IsData: false, selected: { "from": "", "to": "" } },
                        "checkbox": { tmpl: "checkbox.html", IsData: false },
                        "plain": { tmpl: "plain.html", IsData: false, selected: "" },
                        "numberrange": { tmpl: "numberRange.html", IsData: false, selected: { "from": "", "to": "" } },
                        "tree": { tmpl: "tree.html", IsData: false, selected: { "Names": "", selectionIds: [], selectionAllIds: [] } },
                        "advanceddaterange": {
                            tmpl: "advanceDateRange.html", IsData: false,
                            advanceDateTypeOptions: [{ 'title': 'Date Range', 'code': 'dr' }, { 'title': 'Period', 'code': 'p' }],
                            nextPeriodOptions: [],
                            selected: { "from": "", "to": "", advanceDateType: null, nextPeriod: "" }
                        },
                        "selectwithtree": {
                            tmpl: "selectWithTree.html", IsData: true, selected: { "Names": "", selectionIds: [], selectionAllIds: [] }, selectModel: {}
                        }
                    },
                    loaderMapping = {
                        "DocumentStatus": globalSearchService.filter.getAllFilters,
                        "GetAllFilters": globalSearchService.filter.getAllFilters,
                        "p2p_GetAllFilters": globalSearchService.filter.getAllFilters,
                        "PartnerSearch": globalSearchService.filter.partnerSearch,
                        "p2p_GetOrderAuthor": globalSearchService.filter.getAllFilters,
                        "p2p_IRStatus": globalSearchService.filter.getAllFilters,
                        "p2p_GetInvoiceStatus": globalSearchService.filter.getAllFilters,
                    },
                    treeType = { "REGION": "REG", "ORIGIN": "ORG" ,"CATEGORY": "PAS" },
                    isTreeAvail = false, filterFields = [], fieldData = {},
                      treeComponentConfig = {
                          selectedNodes: "",
                          isRadio: false,
                          getHierarchyOnSelection: true,
                          getAllLazyLoadedData: false,
                          isLazyLoad: false,
                          data: null,
                          disableLevelSelection: '',
                          getSelections: false,
                          clearCache: false,
                          height: '328px',
                          isSearchEnabled: true,
                          navigationContext: "PAS",
                          isShowSelected: false,
                          treeType: 'Generic'
                      }, allFilter = scope.filterLinker.Data;
                    //this code is written to update the DOM on filterchip click, tried using 2 way binded variables and watchers, but it was not resolving the bug, thus used jquery click event(not recommended) to get the changes reflected
                    scope.$on('updateFilterTab', function (event, filterData) {
                        if (filterData != scope.filterLinker || APPCONSTANTS.filterLinker != scope.filterLinker)
                            scope.filterLinker = APPCONSTANTS.filterLinker;
						if (filterData.importDocumentFilterTabData != scope.importDocumentFilterTabData)
                            scope.importDocumentFilterTabData = filterData.importDocumentFilterTabData;
						var ind = _.findIndex(filterData.importDocumentFilterTabData, function (tab) { return tab.active == true; }) + 1;
						setTimeout(function () {
						    $('ul.tabs > li:nth-child(' + ind + ')').click();
						}, 500);
                    });
                    _.each(allFilter, function (obj) {
                        var objTmpl = angular.copy(controlTmpl[obj["Type"].toLowerCase()]);
                        if (objTmpl) {
                            var objFieldData = {
                                data: objTmpl.IsData ? obj["ASList"] : "",
                                selected: objTmpl.selected,
                                title: $translate.instant(obj.Value)
                            }
                            if (obj["Type"].toLowerCase() == "tree") {
                                objFieldData.treeComponentConfig = treeComponentConfig;
                                objFieldData.selected["Names"] = "Choose " + objFieldData.title;
                                isTreeAvail = true;
                            }
                            else if (obj["Type"].toLowerCase() == "advanceddaterange") {
                                objFieldData.advanceDateTypeOptions = objTmpl.advanceDateTypeOptions;
                                if (obj["advancedDateRangeFilter"]) {
                                    objFieldData.nextPeriodOptions = _.map(obj["advancedDateRangeFilter"]["LstTimePeriodValue"], function (nxtDay) {
                                        if (nxtDay) {
                                            return {
                                                "title": nxtDay.toString()
                                            };
                                        }
                                    });
                                    objFieldData.selected.nextPeriod = objFieldData.nextPeriodOptions && objFieldData.nextPeriodOptions.length > 0 ? objFieldData.nextPeriodOptions[0] : "";
                                }
                                else {
                                    objFieldData.advanceDateTypeOptions = _.without(objFieldData.advanceDateTypeOptions, _.findWhere(objFieldData.advanceDateTypeOptions, {
                                        code: 'p'
                                    }));
                                }
                                objFieldData.selected.advanceDateType = objTmpl.advanceDateTypeOptions[0];

                            }
                            else if (obj["Type"].toLowerCase() == "autosuggest") {
                                objFieldData.checkElem = objTmpl.checkElem;
                                objFieldData.countSelected = 0;
                                if (objFieldData.data.length > 0) {
                                    objFieldData.isDataLoded = true;
                                    objFieldData.DataLoaded = true;
                                    objFieldData.allData = objFieldData.data;
                                }
                            }
                            fieldData[obj["SearchField"]] = angular.extend(obj, objFieldData);
                            filterFields.push({ title: $translate.instant(obj.Value), contentUrl: objTmpl.tmpl, code: obj["SearchField"] });
                        }
                    });
                    scope.importDocumentFilterTabData = filterFields;
                    scope.filterLinker.importDocumentFilterTabData = scope.importDocumentFilterTabData;
                    if (filterFields.length > 0) {
                        scope.importDocumentFilterTabData[0].active = true;
                        scope.currentFilter = scope.importDocumentFilterTabData[0].code; 
                        scope.filterTabData = fieldData;
                        scope.isTreeAvail = isTreeAvail;
                    }
                    scope.filterLinker.currentFilter = scope.currentFilter;

                }
                var filterResponseMapping = {//The Json properies returned to bind dropdown or mutliselect
                    DM_ExecutionAuthority: { keyProp: "ContactCode", labelProp: "value" },
                    DM_Status: { keyProp: "DocumentStatusId", labelProp: "DocumentStatusDescription", resListName: "ListStatusFilter" },
                    DM_Author: { keyProp: "ContactCode", labelProp: "FirstName", resListName: "ListDocumentContactsFilter" },
                    DM_BusinessUnit: { keyProp: "BUId", labelProp: "BUDescription", resListName: "ListBUFilter" },
                    DM_Partner: { keyProp: "PartnerCode", labelProp: "PartnerName", resListName: "ListPartnerFilter" },
                    DM_Requester: { keyProp: "ContactCode", labelProp: "FirstName", resListName: "ListDocumentContactsFilter" },
                    DM_AccountNumber: { keyProp: "EntityDetailCode", labelProp: "EntityCode", resListName: "ListAccNumberFilter" },
                    DM_GLCode: { keyProp: "GLId", labelProp: "GLcode", resListName: "ListGLcodeFilter" },
                    DM_OrderContact: { keyProp: "ContactCode", labelProp: "FirstName", resListName: "ListDocumentContactsFilter" },
                    FM_FormType: { keyProp: "FormTypeId", labelProp: "FormTypeName" },
                    PM_Partner: { keyProp: "PartnerCode", labelProp: "PartnerName" },
                    SC_ScorecardType: { keyProp: "ScorecardTypeId", labelProp: "ScorecardTypeName", resListName: "ScorecardType" },
                    SC_Purpose: { keyProp: "AssessmentTypeId", labelProp: "AssessmentTypeName", resListName: "AssessmentType" },
                    SC_Frequency: { keyProp: "FrequencyId", labelProp: "FrequencyName", resListName: "AssessmentFrequency" }
                }

                scope.tabFilterSelectCallback = function (e) {
                    if (e.previousTab)
                        e.previousTab.isLoaded = false;  
                    scope.currentFilter = e.code;
                    if (scope.filterTabData[scope.currentFilter].Type.toLowerCase() == "dropdown" && scope.filterTabData[scope.currentFilter].data.length <= 0) {
                        var url = !scope.filterTabData[scope.currentFilter].apiUrl ? mapUrl(scope.filterTabData[scope.currentFilter]) : scope.filterTabData[scope.currentFilter].ASUrl;
                        globalSearchService.filter.filterServiceCall(url, scope.filterTabData[scope.currentFilter].SearchField, null, scope.filterTabData[scope.currentFilter].SearchField, bindListData);

                    }
                    else if (scope.filterTabData[scope.currentFilter].Type.toLowerCase() == "advanceddaterange") {
                        if (!scope.filterTabData[scope.currentFilter].selected.from) {
                            scope.filterTabData[scope.currentFilter].selected.from = new Date();
                        }
                    }
                    else if (scope.filterTabData[scope.currentFilter].Type.toLowerCase() == "autosuggest" && !scope.filterTabData[scope.currentFilter].isDataLoded) {
                        scope.getSuggestedList(scope.filterTabData[scope.currentFilter]);
                        scope.filterTabData[scope.currentFilter].isDataLoded = true;
                    }
                    else if (scope.filterTabData[scope.currentFilter].Type.toLowerCase() == "selectwithtree" && scope.filterTabData[scope.currentFilter].data.length <= 0) {
                        var url = !scope.filterTabData[scope.currentFilter].dropdownData.apiUrl ? mapUrl(scope.filterTabData[scope.currentFilter]) : scope.filterTabData[scope.currentFilter].dropdownData.ASUrl;
                        globalSearchService.filter.filterServiceCall(url, scope.filterTabData[scope.currentFilter].dropdownData.SearchField, null, scope.filterTabData[scope.currentFilter].SearchField, bindListData);
                    }
                }

                var prevVal = "";
                scope.getSuggestedList = function (selected, e) {
                    if (e && typeof e.displayModel != undefined && selected.Type.toLowerCase() == "autosuggest") {
                        selected.selected = e.displayModel;
                    }
                    if ((!selected.allData || selected.allData.length == 0) || (selected.Type.toLowerCase() == "autosuggest" && selected.LoadType.toLowerCase() == "partial" && (selected.prvSelected != selected.selected))) {
                        if (!selected.ASUrl && selected.LoaderKey) {
                            var filterFor = selected.ParentLoaderKey || scope.currentFilter;
                            loaderMapping[selected.LoaderKey](filterFor, { "DocumentTypeCodes": selected.DocTypeCode }, selected.selected, selected.SearchField, bindListData);
                        }
                        else if (selected.ASUrl) {
                            //selected.ASUrl = selected.ASUrl.replace("{$term$}", "").replace("{scope$}", scope.docType).replace("{$ParentFilterValue$}", "");
                                selected.apiUrl = mapUrl(selected);
                                globalSearchService.filter.filterServiceCall(selected.apiUrl, selected.SearchField, selected.selected, selected.SearchField, bindListData);
                        }
                        selected.prvSelected = selected.selected;
                        selected.countSelected = 0;
                    }
                    else {
                        var value = selected.selected;
                        if (prevVal != value) {
                            prevVal = value;
                            selected.data = _.filter(selected.allData, function (obj) {
                                return (obj.label.toLowerCase().indexOf(value.trim().toLowerCase()) > -1);
                            });
                        }
                        else {
                            selected.data = angular.copy(selected.allData);
                        }
                        selected.countSelected = _.filter(selected.data, function (obj) {
                            return obj.selected;
                        }).length;
                    }
                    selected.checkedAll = selected.data.length > 0 && selected.countSelected == selected.data.length;
                    selected.fillpartial = selected.data.length > 0 && selected.countSelected > 0 && selected.countSelected < selected.data.length;
                    scope.filterTabData[selected.SearchField] = selected;
                }
                scope.resetMultiSearch = function (selected) {
                    selected.selected = "";
                    scope.getSuggestedList(selected);
                }

                scope.filterLinker.updateFilterData = function (sField, data) {
                    scope.filterTabData[sField].data = data;
                    scope.filterTabData[sField].countSelected = 0;
                    if (data.length > 0) {
                        scope.filterTabData[sField].isDataLoded = true;
                        scope.filterTabData[sField].DataLoaded = true;
                        scope.filterTabData[sField].allData = data;
                    }
                }

                function bindListData(data, sField) {
                    var selectedFilter = scope.filterTabData[sField].dropdownData || scope.filterTabData[sField];
                    scope.filterTabData[sField].DataLoaded = true;
                    var filterFor = selectedFilter.ParentLoaderKey || sField,
                    filterMap = selectedFilter.ResponseKeyProp == "" ? filterResponseMapping[filterFor] : {
                        resListName: selectedFilter.ResponseContainer, keyProp: selectedFilter.ResponseKeyProp,
                        labelProp: selectedFilter.ResponseLabelProp
                    };
                    var allData = setAutoSuggest(filterMap.resListName ? data[filterMap.resListName] : data, filterMap.keyProp, filterMap.labelProp, scope.filterTabData[sField]["Type"].toLowerCase());

                    scope.filterTabData[sField].data = allData;
                    scope.filterTabData[sField].allData = allData;

                    // Below  code is used when we set default filters on page load.
                    // If there are values in selected then set these values selected in allData
                    if (scope.filterTabData[sField].defaultSelected && scope.filterTabData[sField].defaultSelected.length > 0) {
                        if (scope.filterTabData[sField].dropdownData) {
                            scope.filterTabData[sField].selectModel = _.find(allData, function (c) { return c.code == scope.filterTabData[sField].defaultSelected[0] });
                        }
                        else {
                            _.each(scope.filterTabData[sField].defaultSelected, function (item, index) {
                                _.each(scope.filterTabData[sField].allData, function (_allData, index) {
                                    if (_allData.code == item.code)
                                        _allData.selected = true;
                                });
                            });
                        }
                    }
                    if (!_.isEmpty(scope.filterTabData[sField].defaultSelected)) {
                        scope.filterTabData[sField].countSelected = scope.filterTabData[sField].defaultSelected.length;
                        scope.filterTabData[sField].checkedAll = (scope.filterTabData[sField].data.length == scope.filterTabData[sField].defaultSelected.length);
                        scope.filterTabData[sField].fillpartial = scope.filterTabData[sField].countSelected > 0 && scope.filterTabData[sField].countSelected < scope.filterTabData[sField].data.length;
                    }
                }
                scope.checkedAllDoc = function (selected, check) {
                    selected.fillpartial = false;
                    selected.data = _.map(selected.data, function (obj) {
                        obj.selected = check;
                        var indAll = _.findIndex(selected.allData, function (allObj) {
                            return allObj.code == obj.code;
                        });
                        if (indAll > -1) {
                            selected.allData[indAll].selected = check;
                        }
                        return obj;
                    });
                    selected.countSelected = check ? selected.data.length : 0;
                }

                scope.resetData = function (selected) {
                    scope.checkedAllDoc(selected, false);
                    selected.checkedAll = false
                    selected.fillpartial = false;
                }

                scope.documentListChange = function (selected, indx) {
                    _.each(selected.allData, function (o) {
                        if (selected.data[indx].code == o.code) {
                            o.selected = selected.data[indx].selected;
                            return;
                        }
                    });
                    selected.countSelected = _.filter(selected.data, function (obj) {
                        return obj.selected;
                    }).length;
                    selected.checkedAll = selected.countSelected == selected.data.length;
                    selected.fillpartial = selected.countSelected < selected.data.length && selected.countSelected > 0;
                }
                scope.showSelected = function (selected) {
                    if (!selected.showSelected) {
                        selected.data = _.filter(selected.allData, function (obj) {
                            return obj.selected;
                        })
                        selected.checkElem.text = "All";
                    }
                    else {
                        selected.data = angular.copy(selected.allData);
                        selected.checkElem.text = "Selected";
                    }
                    selected.showSelected = !selected.showSelected;
                    selected.countSelected = _.filter(selected.data, function (obj) {
                        return obj.selected;
                    }).length;
                    selected.checkedAll = selected.countSelected == selected.data.length;
                    selected.fillpartial = selected.countSelected < selected.data.length && selected.countSelected > 0;
                }
                function mapUrl(obj) {
                    if (obj.Type.toLowerCase() == "selectwithtree") {
                        obj = obj.dropdownData;
                    }
                    var url = obj.ASUrl.replace("{$term$}", obj.selected).replace("{scope$}", obj.DocTypeName).replace("{$ParentFilterValue$}", "").replace("{$PartnerStatus$}", "");
                    if (url.indexOf("oloc") <= -1) {
                        url = url + (url.indexOf("?") > -1 ? "&" : "?") + "oloc=101&";
                    }
                    if (obj.Type.toLowerCase() == "autosuggest" && obj.selected && url.indexOf("searchText=" + obj.selected) == -1) {
                        url = url.replace("searchText=", "searchText=" + obj.selected)
                    }
                    if (url.indexOf("[bpc]") > -1) {
                        url = url.split("[bpc]").join(APPCONSTANTS.userPreferences.EncryptedBPC);
                    }
                    else { url = url + "bpc=" + APPCONSTANTS.userPreferences.EncryptedBPC }
                    url = url + "&c=" + APPCONSTANTS.userPreferences.EncryptedBPC;
                    return APPCONSTANTS.userPreferences.URLs.AppURL + url;
                }

                function setAutoSuggest(arr, codeProp, labelProp, type) {
                    var res = [];
                    if (arr) {
                        _.each(arr, function (item, i) {
                            if (!_.find(res, function (a) { return a["id"] == item[codeProp] || a["code"] == item[codeProp] })) {
                                res.push({ code: item[codeProp], label: $translate.instant(item[labelProp]) });
                            }
                        });
                    }
                    return res;
                }

                var treeSelection;
                scope.showTree = function (selected) {
                    if (selected.ASUrl) {
                        RESTApi.setUrl(mapUrl(selected));
                    }
                    //RESTApi.se
                    var treeTypeVal = treeType[selected["TreeType"]] || selected["TreeType"];
                    scope.filterTabData[selected.SearchField].treeComponentConfig.title = selected.Value;
                    selected.treeComponentConfig.requestParameter = {
                        navigationContext: treeType[selected["TreeType"]] || selected["TreeType"],
                        documentCode: null,
                        requestObject: { 'SetDefault': 'false', 'selectedNodes': selected.selected.selectionIds.join(","), CompanyName: "BuyerSqlConn" },
                    }
                    treeSelection = selected.SearchField;
                    selected.showTree = true;
                    scope.filterTabData[selected.SearchField].treeComponentConfig.selectedNodes = selected.selected.selectionIds.join(",");
                }

                scope.hideCallbackForTree = function () {
                    scope.filterTabData[scope.currentFilter].showTree = false;
                    scope.filterTabData[scope.currentFilter].treeComponentConfig.getSelections = true;
                };

                scope.treeComponentCallback = function (e) {
                    scope.filterTabData[scope.currentFilter].selectedData = e.selections;
                    var selName = scope.filterTabData[scope.currentFilter].selected.Names;
                    if (e.selections.length > 1)
                        selName = e.selectionNames[0] + ' +' + (e.selections.length - 1) + ' More';
                    else if (e.selections.length == 1)
                        selName = e.selectionNames[0];
                    else
                        selName = "Choose " + scope.filterTabData[scope.currentFilter].title;
                    scope.filterTabData[scope.currentFilter].selected = {
                        Names: selName, selectionIds: e.selectionIds, selectionAllIds: e.selectionAllIds
                    };
                }

                scope.applyFilter = function () {
                    appliedFilter = [];
                    getSelectedFilters();
                    scope.filterLinker.applyFilter(filterParam);
                    scope.filterLinker.showFilter = false;
                };
                function getSelectedFilters() {
                    filterParam = [];
                    _.each(scope.filterTabData, function (objFilter) {
                        var selValue = getFilterValue(objFilter);
                        if ((selValue != undefined && selValue != null) && (typeof selValue != "string" || selValue != "")) {
                            objFilter.SelectedValue = selValue;
                            var fltData = angular.copy(objFilter);
                            appliedFilter.push(fltData);
                            fltData.Type = objFilter.Type.toLowerCase() == 'selectwithtree' ? 'Tree' : objFilter.Type;
                            filterParam.push(mapFilterInputParams(fltData));
                        }
                    });
                    //advFilterInputParam = _.map(filterParam, function (objFilter) { return _.omit(objFilter, 'title') });
                }
                function getFilterValue(objFilter) {
                    var retValue;
                    switch (objFilter.Type.toLowerCase()) {
                        case 'dropdown':
                            var _objSelected = _.isEmpty(objFilter.selected) ? objFilter.defaultSelected : objFilter.selected;
                            if (!_.isEmpty(_objSelected))
                                retValue = _objSelected.code;
                            break;
                        case 'autosuggest':
                            var selData = [];
                            if (objFilter.allData && objFilter.allData.length > 0) {
                                selData = _.filter(objFilter.allData, function (obj) {
                                    return obj.selected
                                });
                            }
                            else if (_.isEmpty(selData) && !_.isEmpty(objFilter.defaultSelected))
                                selData = objFilter.defaultSelected;

                            if (!_.isEmpty(selData) && selData.length > 0) {
                                var val = _.pluck(selData, "code");
                                retValue = val && val.length > 0 ? val.join() : "";
                            }
                            break;
                        case 'daterange':
                            var frmDate = objFilter.selected.from ? $filter('smartDateFormat')(objFilter.selected.from, "MM/dd/yyyy") : "",
                            toDate = objFilter.selected.to ? $filter('smartDateFormat')(objFilter.selected.to, "MM/dd/yyyy") : "";
                            retValue = frmDate && toDate ? frmDate + "," + toDate : frmDate ? frmDate : toDate ? toDate : "";
                            break;
                        case 'checkbox':
                            retValue = (objFilter.selected != null && objFilter.selected != undefined && objFilter.selected) ? (objFilter.selected ? "1" : "0") : "";
                            break;
                        case 'plain':
                            retValue = objFilter.selected;
                            break;
                        case 'numberrange':
                            var from = objFilter.selected.from, to = objFilter.selected.to;
                            retValue = from && to ? from + "," + to : from ? from : to ? to : "";
                            break;
                        case 'tree':
                            retValue = objFilter.selected.selectionAllIds ? objFilter.selected.selectionAllIds.join() : "";
                            break;
                        case 'selectwithtree':
                            retValue = objFilter.selected.selectionIds ? objFilter.selected.selectionIds.join() : "";
                            break;
                        case 'advanceddaterange':
                            if (objFilter.selected.advanceDateType && objFilter.selected.advanceDateType.code == 'p') {
                                var period = objFilter.selected.nextPeriod.title;
                                if (period && objFilter.selected.from) {
                                    var d = commonUtilities.convertServerDateTimeToNormalDateTime(objFilter.selected.from), toDate = objFilter.selected.to;
                                    switch (objFilter.advancedDateRangeFilter.TimePeriod.toLowerCase()) {
                                        case 'd':
                                            toDate = d.setDate(d.getDate() + period);
                                            break;
                                        case 'm':
                                            toDate = d.setMonth(d.getMonth() + period);
                                            break;
                                        case 'y':
                                            toDate = d.setFullYear(d.getFullYear() + period);
                                            break;
                                        case 'w':
                                            toDate = d.setDate(d.getDate() + (7 * period));
                                            break;
                                    }
                                    objFilter.selected.to = toDate;
                                }
                            }
                            var frmDate = objFilter.selected.from ? $filter('smartDateFormat')(objFilter.selected.from, "MM/dd/yyyy") : "",
                            toDate = objFilter.selected.to ? $filter('smartDateFormat')(objFilter.selected.to, "MM/dd/yyyy") : "";
                            retValue = frmDate && toDate ? frmDate + "," + toDate : frmDate ? frmDate : toDate ? toDate : "";
                            break;
                        default:
                            retValue = "";
                            break;
                    }
                    return retValue;
                }
                scope.labels = {
                    resetButtonConfig: {
                        title: $translate.instant("filter_reset")
                    },
                    canceButtonConfig: {
                        title: $translate.instant("cancel")
                    },
                    loadMoreButtonConfig: {
                        title: $translate.instant("showmoreloading")
                    },
                    saveButtonConfig: {
                        title: $translate.instant("announcement_save")
                    },
                    viewLogButtonConfig: {
                        title: $translate.instant("filte_viewlog")
                    },
                    applyButtonConfig: {
                        title: $translate.instant("filter_apply"),
                    },
                    saveButtonConfig_filter: {
                        title: $translate.instant("announcement_save"),
                    }
                }

                var filterInputMap = {
                    FieldType: "Type",
                    IsCustAttr: "IsCustAttr",
                    SearchKey: "SearchField",
                    Value: "SelectedValue",
                    title: "Value"
                };

                function mapFilterInputParams(objFilter) {
                    var format = angular.copy(filterInputMap);
                    var retInpPara = _.mapObject(format, function (val, key) {
                        return objFilter[val];
                    });
                    return retInpPara;
                    //format.Value = objFilter[format.Value];
                }
                scope.filterLinker.resetFilter = function (isCancel) {
                    var fltData = {}; var isReset = true;
                    if (!isCancel)
                    {
                        appliedFilter = [];
                    }
                    _.each(scope.filterTabData, function (objFilter) {
                        var objAppliedFilter = _.findWhere(appliedFilter, {
                            "SearchField": objFilter.SearchField
                        })
                        isReset = !isCancel || !objAppliedFilter;
                        var objTmpl = angular.copy(controlTmpl[objFilter["Type"].toLowerCase()]);
                        if (objFilter["Type"].toLowerCase() == "tree" || objFilter["Type"].toLowerCase() == "selectwithtree") {
                            if (isReset) {
                                if (!_.isEmpty(objFilter.selected))
                                    objFilter.selected = {};
                                objFilter.selected.selectionIds = [];
                                objFilter.selected.selectionAllIds = [];
                                objFilter.selected["Names"] = $translate.instant('choose_choose') + ' ' + objFilter.title;
                                var dProp = objFilter.dataProperty;
                                if (objFilter.treeData) {
                                    var treeData = [];
                                    _.each(objFilter.treeData[dProp], function (n, i) {
                                        n[objFilter.levelWiseDataProperty] = _.map(n[objFilter.levelWiseDataProperty], function (m) {
                                            m.selection = "0";
                                            return m;
                                        });
                                        treeData.push(n);
                                    });
                                    objFilter.treeData[dProp] = treeData;
                                }
                            }
                            else {
                                objFilter.selected.selectionIds = objAppliedFilter.selected.selectionIds;
                                objFilter.selected.selectionAllIds = objAppliedFilter.selected.selectionAllIds;
                                if (!_.isEmpty(objAppliedFilter.selected.Names) && objAppliedFilter.selected.Names != "Loading...")
                                    objFilter.selected.Names = objAppliedFilter.selected.Names;
                                objFilter.treeData = objAppliedFilter.treeData;
                            }
                            treeSelection = "";
                        }
                        else if (objFilter["Type"].toLowerCase() == "advanceddaterange") {
                            if (isReset) {
                                objFilter.selected = objTmpl.selected;
                                objFilter.advanceDateTypeOptions = objTmpl.advanceDateTypeOptions;
                                if (objFilter["advancedDateRangeFilter"]) {
                                    objFilter.nextPeriodOptions = _.map(objFilter["advancedDateRangeFilter"]["LstTimePeriodValue"], function (nxtDay) {
                                        return {
                                            "title": nxtDay
                                        };
                                    });
                                }
                                else {
                                    objFilter.advanceDateTypeOptions = _.without(objFilter.advanceDateTypeOptions, _.findWhere(objFilter.advanceDateTypeOptions, {
                                        code: 'p'
                                    }));
                                }
                                objFilter.selected.advanceDateType = objTmpl.advanceDateTypeOptions[0];
                            }
                            else {
                                objFilter.selected = objAppliedFilter.selected;
                                objFilter.selected.advanceDateType = objAppliedFilter.selected.advanceDateType;
                            }
                        }
                        else if (objFilter["Type"].toLowerCase() == "autosuggest") {
                            if (isReset) {
                                objFilter.checkElem = objTmpl.checkElem;
                                objFilter.countSelected = 0;
                                objFilter.allData = _.map(objFilter.allData, function (obj) {
                                    obj.selected = false;
                                    return obj;
                                });
                                objFilter.checkedAll = false;
                                objFilter.fillpartial = false;
                                objFilter.defaultSelected = [];
                                if (objFilter.selected) {
                                    objFilter.selected = "";
                                    scope.getSuggestedList(objFilter);
                                }
                            }
                            else {
                                if (objAppliedFilter.selected != objFilter.selected || _.isEmpty(objAppliedFilter.allData)) {
                                    scope.getSuggestedList(objFilter);
                                    objFilter.selected = objAppliedFilter.selected;
                                }
                                else {

                                    objFilter.allData = objAppliedFilter.allData;
                                    objFilter.checkElem = objAppliedFilter.checkElem;
                                    objFilter.countSelected = objAppliedFilter.countSelected;
                                    objFilter.checkedAll = objFilter.countSelected == (_.isEmpty(objFilter.allData) ? 0 : objFilter.allData.length);
                                    objFilter.fillpartial = objFilter.countSelected > 0 && objFilter.countSelected < (_.isEmpty(objFilter.allData) ? 0 : objFilter.allData.length);
                                }
                            }
                            objFilter.data = objFilter.allData;

                        }
                        else {
                            if (isReset) {
                                objFilter.selected = objTmpl.selected;
                                if (!_.isEmpty(objFilter.defaultSelected))
                                    objFilter.defaultSelected = objTmpl.defaultSelected;
                            }
                            else {
                                objFilter.selected = objAppliedFilter.selected;
                            }
                        }
                    });
                    scope.filterLinker.showFilter = false;
                }
            },
            templateUrl: 'workspace/workspaceDirectives/documentFilter/documentFilterTemplate.html'
        };
    }
})(angular);
